import React, { useRef, useState } from 'react'
import { useEffect } from 'react'
import { getEvaluacionProcedimiento, guardarEvaluacion, guardarEvaluacionNumPersonal } from '../../../../API/Gerencia/Procedimientos/Evaluaciones/EvaluacionesRequets'
import { ConfirmDialog, confirmDialog } from 'primereact/confirmdialog'; // To use confirmDialog method
import { Button, RadioButton, Toast, classNames } from 'primereact';
import { useForm } from '../../../../Base/Hooks/useForm';
import { toastShow } from '../../../../Base/Services/ToastService';
import SelectPersonalScreen from './SelectPersonalScreen';
import Loader from '../../../../Base/Components/Loader/Loader';


import './EvaluacionStyles.scss'
import { useParams } from 'react-router-dom';
import { InputTextarea } from 'primereact/inputtextarea';

function EvaluacionScreen() {

    const { IdEvaluacion } = useParams();


    const { values, handleInputChange, setValues, resetForm, setNumber, handleChange, error, setError } = useForm({})

    const toast = useRef(null);


    const [procedimiento, setProcedimiento] = useState({});
    const [preguntas, setPreguntas] = useState([]);
    const [disable, setdisable] = useState(false);
    const [personal, setPersonal] = useState(null);
    const [loading, setLoading] = useState(false);
    const [completada, setCompletada] = useState(false);
    const [requiereIdPersonal, setRequiereIdPersonal] = useState(true);




    const getInfo = async () => {
        setLoading(true);
        const t = await getEvaluacionProcedimiento(IdEvaluacion);
        console.log(t?.procedimiento?.RequiereIdPersonal);
        if (t) {
            setProcedimiento(t?.procedimiento);
            setPreguntas(t?.preguntas);
            setRequiereIdPersonal(t?.procedimiento?.RequiereIdPersonal);
            // if (!t?.procedimiento?.RequiereIdPersonal) {
            //     setRequiereIdPersonal(false);
            // }
        }
        setLoading(false);
    }


    const setPregunta = (p, i) => {
        switch (parseInt(p?.TipoPregunta)) {
            case 1:
                return (<div>
                    <p className={classNames('pregunta', { 'p-invalid': error['p' + p?.IdPregunta] })}> {i + 1}. {p?.Pregunta}</p>
                    <div className='respuestas'>
                        <ol type='a'>
                            {p?.Respuesta1 && <li><div onClick={e => disable ? () => { } : handleChange(1, 'p' + p.IdPregunta)}>
                                <RadioButton name={p?.Pregunta} disabled={disable} checked={values['p' + p?.IdPregunta] === 1} />
                                <label >{p?.Respuesta1}</label>
                            </div></li>}
                            {p?.Respuesta2 && <li><div className="" onClick={e => disable ? () => { } : handleChange(2, 'p' + p?.IdPregunta)}>
                                <RadioButton name={p?.Pregunta} disabled={disable} checked={values['p' + p?.IdPregunta] === 2} />
                                <label >{p?.Respuesta2}</label>
                            </div></li>}
                            {p?.Respuesta3 && <li><div className="" onClick={e => disable ? () => { } : handleChange(3, 'p' + p?.IdPregunta)}>
                                <RadioButton name={p?.Pregunta} disabled={disable} checked={values['p' + p?.IdPregunta] === 3} />
                                <label >{p?.Respuesta3}</label>
                            </div></li>}
                            {p?.Respuesta4 && <li><div className="" onClick={e => disable ? () => { } : handleChange(4, 'p' + p?.IdPregunta)}>
                                <RadioButton name={p?.Pregunta} disabled={disable} checked={values['p' + p?.IdPregunta] === 4} />
                                <label >{p?.Respuesta4}</label>
                            </div></li>}
                            {p?.Respuesta5 && <li><div className="" onClick={e => disable ? () => { } : handleChange(5, 'p' + p?.IdPregunta)}>
                                <RadioButton name={p?.Pregunta} disabled={disable} checked={values['p' + p?.IdPregunta] === 5} />
                                <label >{p?.Respuesta5}</label>
                            </div></li>}
                            {p?.Respuesta6 && <li><div className="" onClick={e => disable ? () => { } : handleChange(6, 'p' + p?.IdPregunta)}>
                                <RadioButton name={p?.Pregunta} disabled={disable} checked={values['p' + p?.IdPregunta] === 6} />
                                <label >{p?.Respuesta6}</label>
                            </div></li>}
                        </ol>
                    </div>
                </div>)

            // CASE 2 PREGUNTA ABIERTA
            case 2:
                return (<div>
                    <p className={classNames('pregunta', { 'p-invalid': error['p' + p?.IdPregunta] })}> {i + 1}. {p?.Pregunta}</p>
                    <div className='respuestas'>
                        <InputTextarea
                        className='col-12 px-4'
                         value={values['p' + p?.IdPregunta]} 
                         onChange={e => handleChange(e.target.value?.replace("'", ""), 'p' + p?.IdPregunta)} 
                         disabled={disable} 
                         />
                    </div>
                </div>)

            default:
                return <div></div>
                break;
        }
    }



    const checkErrors = () => {
        const err = {}
        preguntas.forEach((p, i) => {
            if (!values['p' + p?.IdPregunta]) {
                err['p' + p?.IdPregunta] = true;
            }
        })
        const length = Object.keys(err).length

        setError(err);
        return length
    }

    const guardar = async () => {

        setLoading(true)
        if (checkErrors() > 0) {
            toastShow(toast, 'warn', 'Debe de completar todas las preguntas', `${Object.keys(values).length} / ${preguntas.length} completadas`);
        } else {
            confirmDialog({
                message: 'Una vez guardado no podra modificar su respuesta.',
                header: 'Guardar Evaluación',
                icon: 'pi pi-exclamation-triangle',
                accept: async () => {
                    const respuestas = preguntas.map((p, i) => {
                        console.log(values['p' + p.IdPregunta], p);
                        return {
                            IdPregunta: p?.IdPregunta,
                            IdPersonal: personal?.idpersonal ? personal?.idpersonal : null,
                            RespuestaInt: p?.TipoPregunta == 1 ? values['p' + p.IdPregunta] : null,
                            RespuestaChar: p?.TipoPregunta == 2 ? values['p' + p.IdPregunta] : null
                        }
                    })
                    console.log(respuestas);
                    const t = await guardarEvaluacion(respuestas);
                    if(t.error){
                        toastShow(toast, 'error', 'Error al guardar evaluación')
                    }else{
                        // setdisable(false);
                        setPersonal(null);
                        if(requiereIdPersonal){
                            setCompletada((personal?.idpersonal + ' - ' + personal?.NombreEmpleado).toLowerCase());
                        }else{
                            setCompletada(true)
                            setRequiereIdPersonal(true)
                        }
                        setValues({});
                        toastShow(toast, 'success', 'Evaluación guardada.')
                    }
                    console.log(t);
                },
                reject: () => { }
            })



        }
        setLoading(false);
    }

    const getNumRespuestas = async () => {
        setLoading(true);
        const n = await guardarEvaluacionNumPersonal(personal.idpersonal, 1);
        if (n.length > 0) {
            // setdisable(true);
            const val = {}
            n.forEach((e, i) => {
                val['p' + e?.IdPregunta] = e?.RespuestaInt
            })
            setValues(val);
        }
        setLoading(false);
    }

    useEffect(() => {
        getInfo();
    }, [])



    // useEffect(() => {
    //     getNumRespuestas();
    // }, [personal])





    return (
        <div className='evaluacionScreen' style={{ overflowY: 'scroll' }}>
            <Loader loading={loading} querySelector={'.evaluacionScreen'} />
            <ConfirmDialog />
            <Toast ref={toast} />
            <div className='encabezado'>
                <img className='logo' src={process.env.REACT_APP_Logo_Primario_H} alt='PPF' />
                <div className='titulo'>
                    <h3>{procedimiento?.Titulo}</h3>
                </div>
                <span className='completadas'>{Object.keys(values).length} / {preguntas.length} completadas</span>
            </div>
            {personal || !requiereIdPersonal ? <div className='preguntas'>
                <div className='descripcion'>
                    {requiereIdPersonal && <h5>{personal?.idpersonal} - {personal?.NombreEmpleado}</h5>}
                    <p>Esta evaluación dispone de {preguntas.length} preguntas.</p>
                    <strong>Seleccione una respuesta de cada de las siguientes preguntas:</strong>

                </div>
                {preguntas.map(setPregunta)}
                <div className='botones' style={{ marginBottom: 150  }}>
                    {/* <Button className='p-button-info' label='Cancelar'/> */}
                    <Button className='p-button-success' label='Guardar' onClick={guardar} disabled={disable} />
                </div>
            </div> :
                <div className='preguntas'>
                    {completada && <div>
                        <h3 className='mb-5 text-center' style={{ textTransform: 'uppercase', color: 'green' }}> completo su encuesta.</h3>
                        <h4  className='mb-5 text-center' >Gracias por participar</h4>
                    </div>}
                    <div >
                    { !completada &&(
                        requiereIdPersonal ?
                            <SelectPersonalScreen setPersonal={setPersonal} procedimiento={procedimiento} toast={toast} setLoading={setLoading} />
                            :
                            <div className='d-flex' style={{ flexDirection: 'column', justifyContent: 'center', alignItems: 'center' }}>
                                <h3>Para comenzar presione el boton continuar.</h3>
                                <Button  
                                    label='Continuar'
                                    onClick={() => {
                                       setRequiereIdPersonal(personal?.requiereIdPersonal)
                                    }}
                                />
                            </div>
                            )
                    }
                    </div>
                </div>
            }


        </div>
    )
}

export default EvaluacionScreen